import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import Section from 'components/base/Section';
import { useEffect, useRef, useState } from 'react';
import { Col, Row, Table } from 'react-bootstrap';
import {
  faArrowLeft,
  faDownload,
  faPrint
} from '@fortawesome/free-solid-svg-icons';
// import ChallanTable from './ChallanTable';
import { getService } from 'services/services';
import { useNavigate, useParams } from 'react-router-dom';
import { formatDate } from 'helpers/utils';
import { Container } from 'react-bootstrap';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

interface Detail {
  material: {
    quantity: number;
    name: string;
    material: {
      name: string;
    };
  };
}

interface Challan {
  challandetail: Detail[];
  challan_no?: string;
  vehicle_no?: string;
  driver_name?: string;
  q_date?: any;
  id: string;
  mobile_number: string;
  email: string;
  contractor?: {
    first_name: string;
    last_name: string;

    citydata?: {
      name: string;
    };
    statedata?: {
      name: string;
    };
    countrydata?: {
      name: string;
    };
  };
}

const NewChallan = () => {
  const printRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const [challanData, setChallanData] = useState<Partial<Challan>>({});

  console.log('challanData', challanData);

  const handlePrint = () => {
    if (printRef.current) {
      const printContents = printRef.current.innerHTML;
      const originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      window.location.reload(); // To reload the page after printing
    }
  };

  // const handleDownloadPDF = () => {
  //   if (printRef.current) {
  //     const doc = new jsPDF('p', 'mm', 'a4');

  //     // Adjust styles to match PDF format more closely
  //     doc.html(printRef.current, {
  //       callback: pdf => {
  //         const formattedDate = formatDate(challanData.q_date); // Assuming formatDate function exists
  //         const filename = `challan-${challanData.id}-${formattedDate}.pdf`;

  //         // Add custom styling adjustments
  //         pdf.setFontSize(10); // Set font size
  //         pdf.setFont('helvetica', 'normal'); // Set font type

  //         // Finalize and save the PDF
  //         pdf.save(filename);
  //       },
  //       x: 10, // Add some left margin
  //       y: 10, // Add some top margin
  //       width: 190, // Width within A4 size
  //       windowWidth: 800 // Simulate browser width for rendering
  //     });
  //   }
  // };

  const handleDownloadPDF = () => {
    if (printRef.current) {
      const doc = new jsPDF('p', 'mm', 'a4');
      const a4Width = 190; // Width of A4 page in mm (minus margins)
      const a4Height = 277; // Height of A4 page in mm (minus margins)

      html2canvas(printRef.current, {
        scale: 2 // High scale for better image quality
      }).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const imgWidth = a4Width;
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // Scale image height to maintain aspect ratio

        // Adjust to fit within A4 height if the content is taller than A4
        const finalHeight = imgHeight > a4Height ? a4Height : imgHeight;

        // Add the image to the PDF
        doc.addImage(imgData, 'PNG', 10, 10, imgWidth, finalHeight);

        const formattedDate = formatDate(challanData.q_date); // Assuming formatDate function exists
        const filename = `challan-${challanData.id}-${formattedDate}.pdf`;

        // Save the PDF
        doc.save(filename);
      });
    }
  };

  let totalQuantity = 0;

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'p') {
        event.preventDefault(); // Prevent the default print dialog
        handlePrint();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    fetch();
  }, []);

  const fetch = async () => {
    const response = await getService(`contractorchallan/${id}`);
    if (response.status === 200) {
      setChallanData(response.data[0]);
    }
  };
  return (
    <Container
      style={{
        maxWidth: '210mm', // A4 width
        padding: '10mm', // Adjust padding as needed
        boxSizing: 'border-box', // Include padding in width and height
        margin: '0 auto' // Center align on page
      }}
    >
      <div className="d-flex gap-2 justify-content-between align-items-end mb-4">
        <h2 className="mb-0 flex-1">Challan</h2>
        <Button variant="phoenix-secondary" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} className="me-sm-2" />
          <span className="d-none d-sm-inline-block">Back</span>
        </Button>
        <Button variant="phoenix-secondary" onClick={handleDownloadPDF}>
          <FontAwesomeIcon icon={faDownload} className="me-sm-2" />
          <span className="d-none d-sm-inline-block">Download Challan</span>
        </Button>
        <Button variant="phoenix-secondary" onClick={handlePrint}>
          <FontAwesomeIcon icon={faPrint} className="me-sm-2" />
          <span className="d-none d-sm-inline-block">Print</span>
        </Button>
      </div>
      <div id="printChallan" ref={printRef}>
        <h3 className="text-center py-2">Shree Ram Sagar Constructions</h3>
        <p className="text-center py-2">
          Plot No.6, Omaxe City, 2, Indore Bypass Rd, Red Church Colony,
          Manglaya Sadak, Indore, Madhya Pradesh 453771
        </p>
        <h3 className="text-center py-2">CHALLAN</h3>
        <div className="border mb-5">
          <div className="d-flex ps-3  py-2">
            <text style={{ width: '40%', fontSize: 14 }}>
              Challan No: {challanData.id}
            </text>
            <text style={{ width: '30%', fontSize: 14 }} className="ms-5">
              Date: {formatDate(challanData.q_date)}
            </text>
            <text style={{ width: '30%', fontSize: 14 }}>{}</text>
          </div>
          <div className="d-flex ps-3  py-2">
            <text style={{ width: '40%', fontSize: 14 }}>
              Contractor:{' '}
              {`${challanData?.contractor?.first_name} ${challanData?.contractor?.last_name}`}
            </text>
            <text style={{ width: '30%', fontSize: 14 }} className="ms-5">
              Contact No: {challanData?.mobile_number}
            </text>
            <text style={{ width: '30%', fontSize: 14 }}>
              Email: {challanData?.email}
            </text>
          </div>
        </div>
        <Table bordered responsive className="custom-table">
          <thead>
            <tr>
              <th>SR NO.</th>
              <th>Material Name</th>
              <th className="text-center">Unit</th>
              <th className="text-center">Quantity</th>
            </tr>
          </thead>
          <tbody>
            {challanData?.challandetail &&
              challanData?.challandetail?.map((item: any, index) => {
                totalQuantity += item.quantity;
                return (
                  <tr key={index}>
                    <td className="px-4 py-1">{index + 1}</td>
                    <td className="py-1">{item.material.name}</td>
                    <td className="text-center py-1">{item.unit.unit_title}</td>
                    <td className="text-center py-1">{item.quantity}</td>
                  </tr>
                );
              })}
            <tr>
              <td colSpan={3} className="text-end">
                <strong className="text-center">Total Quantity</strong>
              </td>
              <td className="text-center">
                <strong>{totalQuantity}</strong>
              </td>
            </tr>
          </tbody>
        </Table>
        <div className="text-end py-9 border-bottom">
          <h4>Authorized Signatory</h4>
        </div>
        <div className="print-footer text-center py-4 mb-9">
          <p className="mb-0">
            This challan is generated by ARK-Project ERP system | 2024 ©
            <a href="https://avark.in//" target="_blank" rel="noreferrer">
              Avark
            </a>
          </p>
        </div>
      </div>
    </Container>
  );
};

export default NewChallan;
